import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid, TextField, Select, MenuItem, FormControl, InputLabel, Switch, FormControlLabel, Button, CircularProgress } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { CreatePMCheckpoints, deletePMCheckpoint, getPM_planbyId, getPMCheckpoints } from '../../ReduxStore/PreventiveMaintaince/CreatePMPlan';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomBreadcrumbs from '../Breadcrumb';
import * as XLSX from "xlsx";

const AddPlan = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: ' Preventive Maintenance', href: '/preventive-maintenance' },
        { label: 'Plan Overview', href: '/plan-overview' },
    ];
    const pathname = location.pathname.split('/');
    const plan_id = pathname[2]
    const assetNo = pathname[3]

    const [loadings, setLoading] = useState(true);
    const [pmPlan, setPmPlan] = useState();
    const [activeCheckpoints, setActiveCheckpoints] = useState([]);
    const [pm_checkpoints, setCheckpoints] = useState([]);
    const [formData, setFormData] = useState({
        checkpoint: "",
        frequency: "",
        startDate: "",
        enabled: true
    });
    const [importedCheckpoints, setImportedCheckpoints] = useState([]);

    const handleFileUpload = (event) => {
        const file = event.target.files[0];

        if (!file) return;

        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            const json = XLSX.utils.sheet_to_json(worksheet);

            const checkpoints = json.map((row) => ({
                check_point: row.Checkpoint
            }));

            setImportedCheckpoints(checkpoints);
        };

        reader.readAsArrayBuffer(file);
    };

    const downloadSample = () => {

        const sample = [
            { Checkpoint: "Check Rfid Tag" },
            { Checkpoint: "Physical damage" }
        ];

        const worksheet = XLSX.utils.json_to_sheet(sample);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Checkpoints");

        XLSX.writeFile(workbook, "checkpoint_import_format.xlsx");
    };

    const saveImportedCheckpoints = async () => {

        try {

            const payload = importedCheckpoints.map(item => ({
                plan_id: plan_id,
                check_point: item.check_point
            }));

            for (const checkpoint of payload) {
                await dispatch(CreatePMCheckpoints(checkpoint)).unwrap();
            }

            toast.success("All checkpoints imported successfully");

            setImportedCheckpoints([]);

            getCheckpoints();

        } catch (error) {
            console.log("chech error",error)
            toast.error(error.message);

        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleToggleChange = (e) => {
        setFormData({
            ...formData,
            enabled: e.target.checked
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.checkpoint) {
            toast.error("Enter Checkpoint name")
            return
        }
        const checkpoint = {
            plan_id: plan_id,
            check_point: formData.checkpoint
        }
        try {
            const action = dispatch(CreatePMCheckpoints(checkpoint));
            const response = await action.unwrap();
            console.log("res", response.result);
            if (response.StatusCode === 201) {
                setFormData({
                    ...formData,
                    checkpoint: ""
                })
                getCheckpoints();
            }
        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        }
    };



    // Function to handle the switch toggle for a specific checkpoint
    const toggleCheckpointActive = async (index) => {
        const checkpointName = pm_checkpoints[index].check_point;
        const checkpointId = pm_checkpoints[index].id;

        // Show confirmation alert
        const userConfirmed = window.confirm(
            `Do you want to ${activeCheckpoints[index] ? 'inactive' : 'delete'} the checkpoint "${checkpointName}"?`
        );

        if (userConfirmed) {
            try {
                const action = dispatch(deletePMCheckpoint(checkpointId));
                const response = await action.unwrap();
                if (response.StatusCode === 200) {
                    toast.success(response.message)
                    getCheckpoints();
                }
            } catch (error) {
                toast.error(error.message || "Something went wrong!");
            }

            const updatedCheckpoints = [...activeCheckpoints];
            updatedCheckpoints[index] = !updatedCheckpoints[index]; // Toggle the specific checkpoint's active state
            setActiveCheckpoints(updatedCheckpoints);
        }
    };

    const getPlanbyId = async () => {
        try {
            const action = dispatch(getPM_planbyId(plan_id));
            const res = await action.unwrap();
            console.log("res", res.result)
            setPmPlan(res.result)
            if (res.result) {
                setFormData({
                    ...formData,
                    frequency: res.result.pm_plan
                    [0].frequency,
                    startDate: res.result.pm_plan
                    [0].start_date,
                });
            }
        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        }
    }

    const getCheckpoints = async () => {
        try {
            const action = dispatch(getPMCheckpoints(plan_id));
            const res = await action.unwrap();
            console.log("check setCheckpoints", res.result)
            if (res.result) {
                setCheckpoints(res.result.pm_checkpoints)
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            setCheckpoints([])
            // toast.error(error.message || "Something went wrong!");
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            await getCheckpoints();
            await getPlanbyId();
            setLoading(false);
        };
        fetchData();
    }, [plan_id]);


    return (
        <Layout>
            <Container>
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Add/View Plan" />
                </Box>
                <Box className="add-checkpoint" mb={3}>
                    {/* <Grid container className='row1' spacing={3}>
                        <Grid item xs={6} sm={3}>
                            <Typography variant="body1" style={{ fontSize: '16px', fontWeight: 500 }}>
                                Add Checkpoint
                            </Typography>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            <Button
                                type="button"
                                variant="contained"
                                fullWidth
                                style={{ backgroundColor: '#3f51b5', color: 'white', fontSize: "12px", fontWeight: "400" }}
                            >
                                Import Multiple
                            </Button>
                        </Grid>
                    </Grid> */}
                    <Grid container className="row1" spacing={3} alignItems="center">
                        <Grid item xs={6} sm={3}>
                            <Typography variant="body1" style={{ fontSize: '16px', fontWeight: 500 }}>
                            Add Checkpoint
                            </Typography>
                        </Grid>

                        <Grid item xs={6} sm={3}>
                            <Button
                            variant="contained"
                            component="label"
                            style={{ backgroundColor: "#2e7d32", color: "white" }}
                            >
                            Import Checkpoints
                            <input
                                type="file"
                                hidden
                                accept=".csv,.xlsx"
                                onChange={handleFileUpload}
                            />
                            </Button>
                        </Grid>

                        <Grid item xs={6} sm={3}>
                            <Button
                            variant="outlined"
                            onClick={downloadSample}
                            >
                            Download Format
                            </Button>
                        </Grid>
                    </Grid>
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={3} alignItems="center">
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    label="Checkpoint"
                                    name="checkpoint"
                                    type="text"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.checkpoint}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Frequency</InputLabel>
                                    <Select
                                        value={formData.frequency}
                                        label="Frequency"
                                        name="frequency"
                                        readOnly
                                    >
                                        <MenuItem value="weekly">Weekly</MenuItem>
                                        <MenuItem value="monthly">Monthly</MenuItem>
                                        <MenuItem value="quarterly">Quarterly</MenuItem>
                                        <MenuItem value="halfyearly">Half-Yearly</MenuItem>
                                        <MenuItem value="yearly">Yearly</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    label="Start Date"
                                    name="startDate"
                                    type="date"
                                    variant="outlined"
                                    fullWidth
                                    readOnly
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={formData.startDate}
                                />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    fullWidth
                                    style={{ backgroundColor: '#3f51b5', color: 'white' }}
                                >
                                    Save
                                </Button>
                                {/* <FormControlLabel
                                    control={
                                        <Switch
                                            checked={formData.enabled}
                                            onChange={handleToggleChange}
                                            name="enabled"
                                            color="primary"
                                        />
                                    }
                                    label="Enabled"
                                /> */}
                            </Grid>
                        </Grid>
                        {/* <Grid container style={{ marginTop: "15px" }}>
                            <Grid item xs={6} sm={1}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    fullWidth
                                    style={{ backgroundColor: '#3f51b5', color: 'white' }}
                                >
                                    Save
                                </Button>
                            </Grid>
                        </Grid> */}
                    </form>
                </Box>
                {importedCheckpoints.length > 0 && (
                    <Box className="add-checkpoint" mt={3}>

                    <Grid container className='row1' spacing={3}>
                    <Grid item xs={12} sm={6}>
                    <Typography variant="body1" style={{ fontSize: '16px', fontWeight: 500 }}>
                    Imported Checkpoints Preview
                    </Typography>
                    </Grid>

                    <Grid item xs={12} sm={2}>
                    <Button
                    variant="contained"
                    style={{ backgroundColor: '#3f51b5', color: 'white' }}
                    onClick={saveImportedCheckpoints}
                    fullWidth
                    >
                    Save All
                    </Button>
                    </Grid>
                    </Grid>

                    <Box className="table-container">

                    <Grid container>
                    <Grid item xs={4} sm={3}>
                    <h4>Asset No</h4>
                    </Grid>

                    <Grid item xs={5} sm={3}>
                    <h4>Checkpoint</h4>
                    </Grid>

                    <Grid item xs={2} sm={2}>
                    <h4>Frequency</h4>
                    </Grid>

                    <Grid item xs={4} sm={2}>
                    <h4>Start Date</h4>
                    </Grid>

                    <Grid item xs={2} sm={2}>
                    <h4>Status</h4>
                    </Grid>
                    </Grid>

                    <hr />

                    {importedCheckpoints.map((item, index) => (

                    <Grid container spacing={3} key={index} alignItems="center">

                    <Grid item xs={3}>
                    {assetNo.slice(3)}
                    </Grid>

                    <Grid item xs={3}>
                    {item.check_point}
                    </Grid>

                    <Grid item xs={2}>
                    {formData.frequency}
                    </Grid>

                    <Grid item xs={2}>
                    {formData.startDate}
                    </Grid>

                    <Grid item xs={2}>
                    <Typography style={{color:"#2e7d32",fontWeight:500}}>
                    Ready
                    </Typography>
                    </Grid>

                    </Grid>

                    ))}

                    <hr />

                    </Box>

                    </Box>
                    )}

                <Box className="add-checkpoint" mt={2}>
                    {/* <CheckList data={data} assetNo={assetNo} /> */}

                    <Grid container className='row1' spacing={3}>
                        <Grid item xs={12} sm={3}>
                            <Typography variant="body1" style={{ fontSize: '16px', fontWeight: 500 }}>
                                Checkpoints List
                            </Typography>
                        </Grid>
                    </Grid>
                    <Box className="table-container">
                        <Grid container>
                            <Grid item xs={4} sm={3}>
                                <h4>Asset No</h4>
                            </Grid>
                            <Grid item xs={5} sm={3}>
                                <h4>Checkpoint</h4>
                            </Grid>
                            <Grid item xs={2} sm={2}>
                                <h4>Frequency</h4>
                            </Grid>
                            <Grid item xs={4} sm={2}>
                                <h4>Start Date</h4>
                            </Grid>
                            <Grid item xs={2} sm={2}>
                                <h4>Enabled</h4>
                            </Grid>
                        </Grid>
                        <hr />
                        {/* <Box className="table-content">
                            {loadings ? (
                                <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                                    <CircularProgress />
                                </Box>
                            ) : (
                                pm_checkpoints.length > 0 && pm_checkpoints.map((item, index) => (
                                    <Grid container spacing={3} key={index} alignItems='center'>
                                        <Grid item xs={3}>
                                            {(assetNo).slice(3)}
                                        </Grid>
                                        <Grid item xs={3}>
                                            {item.check_point}
                                        </Grid>
                                        <Grid item xs={2}>
                                            {formData.frequency}
                                        </Grid>
                                        <Grid item xs={2}>
                                            {formData.startDate}
                                        </Grid>
                                        <Grid item xs={2}>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={item.active}
                                                        // checked={activeCheckpoints[index]}
                                                        name="enabled"
                                                        color="primary"
                                                        onClick={() => toggleCheckpointActive(index)}
                                                    />
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                ))
                            )}
                            <hr />
                        </Box> */}
                        <Box className="table-content">
                            {loadings ? (
                                <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                                    <CircularProgress />
                                </Box>
                            ) : (
                                pm_checkpoints.length > 0 ? (
                                    pm_checkpoints.map((item, index) => (
                                        <Grid container spacing={3} key={index} alignItems="center">
                                            <Grid item xs={3}>
                                                {(assetNo).slice(3)}
                                            </Grid>
                                            <Grid item xs={3}>
                                                {item.check_point}
                                            </Grid>
                                            <Grid item xs={2}>
                                                {formData.frequency}
                                            </Grid>
                                            <Grid item xs={2}>
                                                {formData.startDate}
                                            </Grid>
                                            <Grid item xs={2}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={item.active}
                                                            name="enabled"
                                                            color="primary"
                                                            onClick={() => toggleCheckpointActive(index)}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                    ))
                                ) : (
                                    <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                                        <Typography>No checkpoint available</Typography>
                                    </Box>
                                )
                            )}
                            <hr />
                        </Box>

                    </Box>
                </Box>
            </Container>
            {/* <ToastContainer position="bottom-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ width: '90%', maxWidth: '400px' }} /> */}
            <ToastContainer />
        </Layout>
    );
};

export default AddPlan;
